export default {"src":"/_next/static/media/kidney_stones.2afb413b.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};